// extracted by mini-css-extract-plugin
export default {"wrapper":"OTCInput_wrapper","cell":"OTCInput_cell","cellCurrent":"OTCInput_cellCurrent","input":"OTCInput_input"};